import { ControllerFieldState } from 'react-hook-form';

export function getFieldMeta(fieldState: ControllerFieldState): {
  error: string | undefined;
} {
  return {
    error: fieldState.error?.message || undefined,
  };
}
